import React, { memo } from 'react';

const ListInner = () => (
    <svg viewBox="0 0 18 16">
        <path d="M0 0H4V4H0V0ZM6 1V3H18V1H6ZM0 6H4V10H0V6ZM6 7V9H18V7H6ZM0 12H4V16H0V12ZM6 13V15H18V13H6Z" />
    </svg>
);

export const List = memo(ListInner);
